import axios from "axios";
import moment from "moment";

export function fetchEvents(offset = 0, limit = 50) {
  clearEvents();

  return function (dispatch) {
    let url = new URL(window.location.href);
    let today = url.searchParams.get("today");

    let startTime = moment().subtract(1, "days").format("YYYY-MM-DD");
    if (today !== null) {
      startTime = moment(today).subtract(1, "days").format("YYYY-MM-DD");
    }

    axios
      .get("/v1/events/?assessed_by_me=true&assessed=false&attending_only=true&is_cancelled=false&type=practice&limit=" + limit + "&offset=" + offset)
      .then((response) => {
        if (response.data) {
          dispatch({
            type: "FETCH_EVENTS",
            payload: response.data.results
          });
        }
      })
      .catch(function (err) {
        console.warn("API Error: getting events", err);
      });
  };
}

export function fetchEventDetails(eventId) {
  return function (dispatch) {
    dispatch({
      type: "GETTING_EVENT_DETAILS",
      eventId: eventId
    });

    axios
      .get("/v1/events/" + eventId + "/?attending_only=true")
      .then((response) => {
        if (response.data) {
          dispatch({
            type: "ADD_EVENT_DETAILS",
            eventId: eventId,
            payload: response.data
          });
        }
      })
      .catch(function (err) {
        console.warn("API Error: getting event details", err);
      });
  };
}

export function clearEvents() {
  return {
    type: "CLEAR_EVENTS"
  };
}

export function clearEventDetails(eventId) {
  return {
    type: "CLEAR_EVENT_DETAILS",
    eventId
  };
}



// WEBPACK FOOTER //
// ./actions/events.js